/* =============================================================================
   THEODORA WARRE - Theme JS
   ============================================================================= */

(function () {
  'use strict';

  // ============================================================
  // Mobile Menu
  // ============================================================
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileDrawer = document.getElementById('mobile-menu-drawer');
  const mobileOverlay = document.getElementById('mobile-menu-overlay');
  const mobileClose = document.getElementById('mobile-menu-close');

  function openMobileMenu() {
    mobileDrawer && mobileDrawer.classList.add('open');
    mobileOverlay && mobileOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    mobileDrawer && mobileDrawer.classList.remove('open');
    mobileOverlay && mobileOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  mobileToggle && mobileToggle.addEventListener('click', openMobileMenu);
  mobileClose && mobileClose.addEventListener('click', closeMobileMenu);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobileMenu);

  // Mobile filter toggle (collection page)
  const filterToggle = document.getElementById('mobile-filter-toggle');
  const sidebar = document.getElementById('collection-sidebar');

  filterToggle && filterToggle.addEventListener('click', function () {
    sidebar && sidebar.classList.toggle('open');
  });

  // ============================================================
  // Currency Selector
  // ============================================================
  const currencyToggle = document.querySelector('.currency-toggle');
  const currencyDropdown = document.querySelector('.currency-dropdown');

  if (currencyToggle && currencyDropdown) {
    currencyToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      const isOpen = currencyDropdown.classList.toggle('open');
      currencyToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    document.addEventListener('click', function () {
      currencyDropdown.classList.remove('open');
      currencyToggle.setAttribute('aria-expanded', 'false');
    });

    currencyDropdown.addEventListener('click', function (e) {
      e.stopPropagation();
      const btn = e.target.closest('[data-country]');
      if (!btn) return;
      const input = document.getElementById('localization-country-input');
      const form = document.getElementById('localization-form');
      if (input && form) {
        input.value = btn.dataset.country;
        form.submit();
      }
    });
  }

  // ============================================================
  // Search Overlay
  // ============================================================
  const searchOverlay = document.getElementById('search-overlay');
  const searchToggleBtns = document.querySelectorAll('[data-search-toggle]');
  const searchCloseBtn = document.getElementById('search-close');
  const searchInput = searchOverlay && searchOverlay.querySelector('.search-input');

  function openSearch() {
    searchOverlay && searchOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    searchInput && setTimeout(() => searchInput.focus(), 100);
  }

  function closeSearch() {
    searchOverlay && searchOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  searchToggleBtns.forEach(btn => btn.addEventListener('click', openSearch));
  searchCloseBtn && searchCloseBtn.addEventListener('click', closeSearch);

  searchOverlay && searchOverlay.addEventListener('click', function (e) {
    if (e.target === searchOverlay) closeSearch();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeMobileMenu();
      closeCart();
    }
  });

  // ============================================================
  // Cart Drawer
  // ============================================================
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartCloseBtn = document.getElementById('cart-drawer-close');
  const cartToggleBtns = document.querySelectorAll('[data-cart-toggle]');

  function openCart() {
    cartDrawer && cartDrawer.classList.add('open');
    cartOverlay && cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }

  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('open');
    cartOverlay && cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartToggleBtns.forEach(btn => btn.addEventListener('click', openCart));
  cartCloseBtn && cartCloseBtn.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => renderCartDrawer(cart))
      .catch(console.error);
  }

  function renderCartDrawer(cart) {
    const itemsEl = document.getElementById('cart-drawer-items');
    const countEls = document.querySelectorAll('[data-cart-count]');
    const subtotalEl = document.getElementById('cart-subtotal');

    countEls.forEach(el => {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });

    if (subtotalEl) {
      subtotalEl.innerHTML = formatMoney(cart.total_price);
    }

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer-empty">Your cart is empty</div>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-drawer-item" data-line-key="${item.key}">
        <div class="cart-item-image">
          <a href="${item.url}">
            <img src="${item.image ? item.image.replace('.jpg', '_160x200.jpg') : ''}" alt="${escapeHtml(item.title)}" loading="lazy">
          </a>
        </div>
        <div class="cart-item-body">
          <div class="cart-item-title"><a href="${item.url}">${escapeHtml(item.product_title)}</a></div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${escapeHtml(item.variant_title)}</div>` : ''}
          <div class="cart-item-price">${formatMoney(item.price)}</div>
          <div class="cart-item-qty">
            <button class="qty-dec" aria-label="Decrease quantity">−</button>
            <input type="number" value="${item.quantity}" min="0" class="qty-input" data-key="${item.key}">
            <button class="qty-inc" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <div class="cart-item-remove">
          <button data-remove-key="${item.key}" aria-label="Remove item">
            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      </div>
    `).join('');

    // Bind quantity & remove events
    itemsEl.querySelectorAll('.qty-dec').forEach(btn => {
      btn.addEventListener('click', function () {
        const input = this.parentElement.querySelector('.qty-input');
        updateCartItem(input.dataset.key, Math.max(0, parseInt(input.value) - 1));
      });
    });

    itemsEl.querySelectorAll('.qty-inc').forEach(btn => {
      btn.addEventListener('click', function () {
        const input = this.parentElement.querySelector('.qty-input');
        updateCartItem(input.dataset.key, parseInt(input.value) + 1);
      });
    });

    itemsEl.querySelectorAll('.qty-input').forEach(input => {
      input.addEventListener('change', function () {
        updateCartItem(this.dataset.key, parseInt(this.value));
      });
    });

    itemsEl.querySelectorAll('[data-remove-key]').forEach(btn => {
      btn.addEventListener('click', function () {
        updateCartItem(this.dataset.removeKey, 0);
      });
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    })
      .then(r => r.json())
      .then(cart => renderCartDrawer(cart))
      .catch(console.error);
  }

  // ============================================================
  // Add to Cart (AJAX)
  // ============================================================
  const addToCartForms = document.querySelectorAll('[data-add-to-cart-form]');

  addToCartForms.forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart-btn]');
      const formData = new FormData(form);
      const data = {};
      formData.forEach((v, k) => data[k] = v);

      if (btn) {
        btn.disabled = true;
        btn.textContent = btn.dataset.loadingText || 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: data.id, quantity: parseInt(data.quantity) || 1 })
      })
        .then(r => r.json())
        .then(() => {
          if (btn) {
            btn.textContent = btn.dataset.addedText || 'Added!';
            setTimeout(() => {
              btn.disabled = false;
              btn.textContent = btn.dataset.defaultText || 'Add to Cart';
            }, 2000);
          }
          openCart();
        })
        .catch(err => {
          console.error(err);
          if (btn) {
            btn.disabled = false;
            btn.textContent = btn.dataset.defaultText || 'Add to Cart';
          }
        });
    });
  });

  // ============================================================
  // Product Gallery
  // ============================================================
  const gallery = document.getElementById('product-gallery');

  if (gallery) {
    const mainImg = gallery.querySelector('.gallery-main-img');
    const thumbs = gallery.querySelectorAll('.gallery-thumb');
    const videos = gallery.querySelectorAll('.gallery-main-video');
    // No native controls; click/tap the video to play or pause
    videos.forEach(v => {
      const el = v.querySelector('video');
      if (el) el.addEventListener('click', () => { el.paused ? el.play() : el.pause(); });
    });

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', function () {
        thumbs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');

        videos.forEach(v => {
          v.hidden = true;
          const el = v.querySelector('video');
          if (el) el.pause();
        });

        if (this.dataset.videoId) {
          const target = gallery.querySelector(`.gallery-main-video[data-media-id="${this.dataset.videoId}"]`);
          if (target) {
            if (mainImg) mainImg.hidden = true;
            target.hidden = false;
            const el = target.querySelector('video');
            if (el) el.play().catch(() => {});
          }
          return;
        }

        if (mainImg) {
          mainImg.hidden = false;
          mainImg.src = this.dataset.full || this.querySelector('img').src;
          mainImg.alt = this.querySelector('img').alt;
        }
      });
    });
  }

  // ============================================================
  // Product Variant Selection
  // ============================================================
  const variantForm = document.getElementById('product-form');

  if (variantForm) {
    const productData = JSON.parse(document.getElementById('product-json')?.textContent || '{}');
    const variants = productData.variants || [];
    const addToCartBtn = variantForm.querySelector('[data-add-to-cart-btn]');
    const priceEl = document.querySelector('[data-product-price]');
    const comparePriceEl = document.querySelector('[data-product-compare-price]');
    const variantIdInput = variantForm.querySelector('[name="id"]');

    function getSelectedOptions() {
      const options = {};
      variantForm.querySelectorAll('[data-option-name]').forEach(input => {
        if (input.type === 'radio' && input.checked) {
          options[input.dataset.optionName] = input.value;
        } else if (input.tagName === 'SELECT') {
          options[input.dataset.optionName] = input.value;
        }
      });
      return options;
    }

    function findVariant(selectedOptions) {
      return variants.find(v => {
        return v.options.every((opt, i) => {
          const key = `option${i+1}`;
          return selectedOptions[`option${i+1}`] === opt || Object.values(selectedOptions)[i] === opt;
        });
      });
    }

    function updateVariant() {
      const selectedOptions = getSelectedOptions();
      const optionValues = Object.values(selectedOptions);
      const variant = variants.find(v => v.options.every((opt, i) => optionValues[i] === opt));

      if (variant && variantIdInput) {
        variantIdInput.value = variant.id;
      }

      if (addToCartBtn) {
        if (!variant || !variant.available) {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = variant ? (addToCartBtn.dataset.soldOutText || 'Sold Out') : (addToCartBtn.dataset.unavailableText || 'Unavailable');
        } else {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = addToCartBtn.dataset.defaultText || 'Add to Cart';
        }
      }

      if (variant && priceEl) {
        priceEl.innerHTML = formatMoney(variant.price);
      }
      if (comparePriceEl) {
        if (variant && variant.compare_at_price > variant.price) {
          comparePriceEl.innerHTML = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      // Update gallery if variant has an image
      if (variant && variant.featured_image) {
        const variantThumb = document.querySelector(`.gallery-thumb[data-variant-id="${variant.id}"]`);
        if (variantThumb) variantThumb.click();
      }
    }

    variantForm.querySelectorAll('[data-option-name]').forEach(input => {
      input.addEventListener('change', function () {
        // Update .selected class on sibling labels
        const group = this.closest('.variant-options');
        if (group) {
          group.querySelectorAll('.variant-option').forEach(label => label.classList.remove('selected'));
          this.closest('.variant-option') && this.closest('.variant-option').classList.add('selected');
        }
        updateVariant();
      });
    });
  }

  // Accordions use native <details>/<summary> — no JS needed.

  // ============================================================
  // Quantity Selector (product page)
  // ============================================================
  document.querySelectorAll('.quantity-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.closest('.quantity-selector').querySelector('.quantity-input');
      if (!input) return;
      const current = parseInt(input.value) || 1;
      if (this.dataset.action === 'dec') {
        input.value = Math.max(1, current - 1);
      } else {
        input.value = current + 1;
      }
    });
  });

  // ============================================================
  // Sticky header adjustment
  // ============================================================
  function updateHeaderOffset() {
    const header = document.querySelector('.site-header');
    if (header) {
      const h = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
  }
  updateHeaderOffset();
  window.addEventListener('resize', updateHeaderOffset);

  // ============================================================
  // Helpers
  // ============================================================
  function formatMoney(cents) {
    if (typeof window.moneyFormat === 'string') {
      return window.moneyFormat.replace('{{amount}}', (cents / 100).toFixed(2))
        .replace('{{amount_no_decimals}}', Math.round(cents / 100))
        .replace('{{amount_with_comma_separator}}', (cents / 100).toFixed(2).replace('.', ','));
    }
    return '£' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Initialise cart count on load
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.setAttribute('data-count', cart.item_count);
      });
    })
    .catch(() => {});

})();
